<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <header class="bg-emerald-600 text-white py-6 px-4">
      <div class="max-w-4xl mx-auto">
        <!-- Mid-game, back should mean "back to the games list" — leaving the
             app entirely is a bigger jump than the learner asked for. -->
        <button
          v-if="selected"
          type="button" @click="selected = null"
          class="text-emerald-200 hover:text-white text-sm font-medium"
        >&larr; Back to games</button>
        <h1 class="text-2xl font-bold mt-2">Games</h1>
        <p class="mt-1 text-emerald-100">Quick, replayable practice — earn XP and keep your streak alive.</p>
      </div>
    </header>

    <main class="max-w-4xl mx-auto px-4 py-8">
      <SpeedMatch v-if="selected === 'speed_match'" @exit="selected = null" />
      <DailyChallenge v-else-if="selected === 'daily_challenge'" @exit="selected = null" />
      <ToneMatch v-else-if="selected === 'tone_trainer'" @exit="selected = null" />
      <WordFall v-else-if="selected === 'word_fall'" @exit="selected = null" />

      <div v-else class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <button
          v-for="game in games"
          :key="game.id"
          :disabled="game.comingSoon"
          @click="!game.comingSoon && (selected = game.id)"
          class="text-left bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-5 transition-all"
          :class="game.comingSoon ? 'opacity-60 cursor-not-allowed' : 'hover:shadow-md hover:-translate-y-0.5 hover:border-emerald-300 dark:hover:border-emerald-500'"
        >
          <div class="flex items-start justify-between">
            <span class="grid place-items-center w-12 h-12 rounded-xl text-2xl" :class="game.tint">{{ game.icon }}</span>
            <span v-if="game.comingSoon" class="text-xs bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-2 py-0.5 rounded-full">Soon</span>
          </div>
          <h3 class="mt-4 text-lg font-semibold text-gray-900 dark:text-gray-100">{{ game.label }}</h3>
          <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">{{ game.description }}</p>
        </button>
      </div>
    </main>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import SpeedMatch from './games/SpeedMatch.vue'
import DailyChallenge from './games/DailyChallenge.vue'
import ToneMatch from './games/ToneMatch.vue'
import WordFall from './games/WordFall.vue'

const selected = ref(null)

const games = [
  { id: 'daily_challenge', icon: '🗓️', tint: 'bg-amber-100', label: 'Daily Challenge', description: 'A fresh mixed gauntlet every day. Bonus XP for finishing.' },
  { id: 'speed_match', icon: '⚡', tint: 'bg-emerald-100', label: 'Speed Match', description: 'Match Vietnamese to English against the clock.' },
  { id: 'tone_trainer', icon: '🎵', tint: 'bg-violet-100', label: 'Tone Match', description: 'Hear it, pick the tone, build a combo.' },
  { id: 'word_fall', icon: '🌧️', tint: 'bg-sky-100', label: 'Word Fall', description: 'Tap the meaning before the word lands.' },
]
</script>
